import * as membersAreaSiteConfiguration from '@wix/auto_sdk_members-area_members-area-site-configuration';
import * as santaMember from '@wix/auto_sdk_members-area_santa-member';

export { membersAreaSiteConfiguration, santaMember };
